import { Center, Flex, Spinner, Stack, Text, VStack } from "@chakra-ui/react"
import startCase from "lodash/startCase"
import React, { useState } from "react"
import { AssignUserRoleForm } from "../../forms"
import { ExtendedUserFragment, useUserRoleGroupByIdQuery } from "../../graphql"
import { Card, Stat } from "../common"

export type AssignUserRoleProps = {
	user: ExtendedUserFragment
}

export const AssignUserRole: React.FC<AssignUserRoleProps> = ({ user }) => {
	const [selectedUserRoleGroupId, setSelectedUserRoleGroupId] = useState("")

	const [{ data, fetching, error }] = useUserRoleGroupByIdQuery({ variables: { userRoleGroupId: selectedUserRoleGroupId }, pause: !selectedUserRoleGroupId })
	return (
		<VStack w="full" spacing={6}>
			<Stack w="full" direction={{ base: "column", xl: "row" }} spacing={6}>
				<VStack w="full" maxW="sm">
					<AssignUserRoleForm user={user} onSelectGroup={setSelectedUserRoleGroupId} />
				</VStack>
				{selectedUserRoleGroupId && (
					<Card title="Selected Role" maxW="xl">
						{fetching ? (
							<Center w="full" py="4">
								<VStack w="full" color="grayscale.label">
									<Text fontSize="sm">Loading details</Text>
									<Spinner size="sm" />
								</VStack>
							</Center>
						) : error ? (
							<Center py="4">
								<Text fontSize="sm" fontWeight="semibold" color="error.500">
									{error.message.replace("[GraphQL] ", "")}
								</Text>
							</Center>
						) : data?.userRoleGroupById ? (
							<Flex justify="center" align="center" flexWrap="wrap">
								<Stat label="User Role Type" value={startCase(data?.userRoleGroupById.type)} />
								<Stat label="User Role Group" value={data?.userRoleGroupById.label.name} />
								<Stat label="Department" value={data?.userRoleGroupById.department.label.name} />
								{data.userRoleGroupById.workShift && (
									<Stat label="Work Shift" value={`${data?.userRoleGroupById.workShift.label.name} (${data?.userRoleGroupById.workShift.startAt}-${data?.userRoleGroupById.workShift.endAt})`} />
								)}
								{data?.userRoleGroupById.allowedZones?.length ? (
									<Stat label="Allowed Zones" value={data?.userRoleGroupById.allowedZones.map((zone) => zone.label.name).join(", ")} />
								) : data?.userRoleGroupById.allowedZoneGroups?.length ? (
									<Stat label="Allowed Zone Groups" value={data?.userRoleGroupById.allowedZoneGroups.map((group) => group.label.name).join(", ")} />
								) : data?.userRoleGroupById.patrollingRouteId && data.userRoleGroupById.patrollingRoute ? (
									<Flex justify="center" align="center" flexWrap="wrap" letterSpacing={0.5}>
										<Stat label="Name" value={data.userRoleGroupById.patrollingRoute.label.name} />
										<Stat label="Min. Time" value={data.userRoleGroupById.patrollingRoute.minTime} />
										<Stat label="Max. Time" value={data.userRoleGroupById.patrollingRoute.maxTime} />
										<Stat label="Rounds" value={data.userRoleGroupById.rounds} />
										<Flex justify="center" align="center" flexWrap="wrap">
											{data.userRoleGroupById.patrollingRoute.zoneIds
												.map((id) => data.userRoleGroupById?.patrollingRoute?.zones.find((z) => z._id === id))
												.filter(Boolean)
												.map((zone, index) => (
													<Text key={zone?._id} textAlign="center" fontSize="sm" fontWeight="bold" color="grayscale.body">
														{zone?.label.name}
														{index < (data.userRoleGroupById?.patrollingRoute?.zones.length || 0) && ", "}
													</Text>
												))}
										</Flex>
										<Text textAlign="center" fontSize="xs" color="grayscale.label">
											Route
										</Text>
									</Flex>
								) : (
									<></>
								)}
							</Flex>
						) : (
							<Center py="4">
								<Text fontSize="sm" fontWeight="semibold" color="error.500">
									Couldn&apos;t find details
								</Text>
							</Center>
						)}
					</Card>
				)}
			</Stack>
		</VStack>
	)
}
